module.exports = __webpack_public_path__ + "img/Procena360.9fd11f8a.jpg";